class mWishlistAlert extends HTMLDivElement {
    constructor() {
        super();
    }

    connectedCallback() {
        setTimeout(() => {
            this.classList.add('active');
            this.waitAndHideMyself();
        }, 50);
    }

    waitAndHideMyself() {
        setTimeout(() => {
            this.classList.add('hidden');
            this.waitAndDeleteMyself();
        }, 3000);
    }

    waitAndDeleteMyself() {
        setTimeout(() => {
            this.parentNode.removeChild(this);
        }, 300);
    }
}

customElements.define('m-wishlist-alert', mWishlistAlert, {
    extends: 'div'
});

